import { APICadimo5Url } from "../../../services/constants";
export const API_CADIMO5 = `${APICadimo5Url}`;
